export default __webpack_public_path__ + "static/media/bell-icon.2c929f0d.svg";